import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ImportPlacanjeStarihRacunaDto, RacuniClient } from '@kodit/core/data-api';
import { AlertService } from '@kodit/core/services';
import { FileUploadService } from '@kodit/core/shared-ui';
import { LoaderService } from 'libs/core/shared-ui/src/lib/loader/loader.service';
import { Subscription } from 'rxjs';
import * as XLSX from 'xlsx';

@Component({
  selector: 'kodit-placanje-racuna-import',
  templateUrl: './placanje-racuna-import.component.html',
  styleUrls: ['./placanje-racuna-import.component.scss']
})
export class PlacanjeRacunaImportComponent implements OnInit {

  private _uploadSub: Subscription = new Subscription();

  /** Props */
  uploadCompleted: boolean;
  readonly MAX_FILE_SIZE: number = 10000000;

  selectedDate : FormControl;

  constructor(
    private _alertService: AlertService,
    private _uploadService: FileUploadService,
    private _loaderService: LoaderService,
    private _client: RacuniClient
  ) { }

  ngOnInit(): void {
    this._uploadService.setMaxAttachmentSize = this.MAX_FILE_SIZE;
    this.selectedDate = new FormControl(new Date());
  }

  onUpload(file: File) {
    this.uploadCompleted = false;
    this._loaderService.setShowLoader = true;
    this.uploadCompleted = false;
    this._uploadSub = this._client
      .placanjeStarihRacuna({
        data: file,
        fileName: '',
      }, this.selectedDate.value)
      .subscribe(
        async (res) => {
          this.uploadCompleted = true;
           if(res.data.length != 0){
                this.exportToExcel(res.data);
                this._alertService.addWarnMsg("Na Vašem računaru preuzet je novi Excel sa podacima koje niste ispravno uneli. Ispravite ih i ponovo otpremite file.");
                await new Promise(resolve => setTimeout(resolve, 3000));
                location.reload();
              }else{
                this._alertService.addSuccessMsg("Uspešno plaćeni stari računi.");
                await new Promise(resolve => setTimeout(resolve, 2000));
                location.reload();
              }
        },
        (error) => {
          this.uploadCompleted = true;
        },
        () => {
          this._loaderService.reset();
        }
      );
  }

  downloadTemplate() {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute(
      'href',
      '/assets/podesavanje/import_files/placanje_starih_racuna_sablon.xlsx'
    );
    link.setAttribute('download', 'placanje_starih_racuna_sablon.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  exportToExcel = (roba: ImportPlacanjeStarihRacunaDto[]) => {
    const workbook = XLSX.utils.book_new();
    const columns = [
      { field: 'identifikacioniBroj', header: 'PIB-MB-JMBG' },
      { field: 'potrazivanje', header: 'Potraživanje' },
      { field: 'dugovanje', header: 'Dugovanje' },
      { field: 'greska', header: 'Greška' }
    ];

    const worksheet1 = XLSX.utils.aoa_to_sheet([
      columns.map(col => col.header),
      ...roba.map((row: { [x: string]: any; }) =>
        columns.map(col => row[col.field] || '')
      )
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet1, 'neispravni_podaci');
    XLSX.writeFile(workbook, `neispravni-podaci.xlsx`);
  };

}
